type ModalDimmedPropsType = {
  onClose: React.MouseEventHandler<HTMLDivElement>;
};

const ModalDimmed = ({ onClose }: ModalDimmedPropsType): React.ReactElement => (
  <div
    className="z-10 fixed mobile:block top-0 left-0 w-full h-full dimmed_40"
    onClick={onClose}
  />
);

export default ModalDimmed;
